import { Empty, Spin } from 'antd';
import React, { useEffect } from 'react';
import { useParams } from 'react-router';
import useFacilityTariffs from '../../../../queries/useFacilityTariffs';
import Tariff from '../Tariff/Tariff';
import queries from '../../../../queries/queries';
import styles from './FacilityTariffs.module.scss';

const FacilityTariffs = ({ facility, setQueryKeys }) => {
  const params = useParams();
  const { data: tariffs, isFetching } = useFacilityTariffs(params.facilityId);

  useEffect(() => {
    setQueryKeys((prev) =>
      prev.concat([[queries.facilityTariffs, params.facilityId]])
    );
  }, [params.facilityId]);
  return (
    <Spin spinning={isFetching}>
      <div className={styles.tariffsLayout}>
        {tariffs?.map((tariff) => {
          return <Tariff key={tariff.id} tariff={tariff} facility={facility} />;
        })}
      </div>
      {!tariffs?.length && <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />}
    </Spin>
  );
};

export default FacilityTariffs;
